
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Hex extends Vue {
  @Prop({ type: Boolean, default: false })
  hoverable!: boolean;

  @Prop({ type: Boolean, default: false })
  shadow!: boolean;

  @Prop({ type: Number, default: 25 })
  size!: number;

  @Prop({ type: String, default: 'px' })
  unit!: string;

  @Prop({ type: Boolean, default: true })
  border!: boolean;

  @Prop({ type: String, default: 'bg-orion-green' })
  borderColor!: string;

  get parentClasses() {
    let classes = '';
    if (this.hoverable) {
      classes += ' hex-hoverable';
    } else if (this.shadow) {
      classes += ' hex-shadow';
    }
    return classes;
  }

  get width() {
    return `${this.size + this.size / 2}${this.unit}`;
  }
  get height() {
    return `${this.size}${this.unit}`;
  }
}
